import ApiService from '@/app/framework/services/ApiServices'
import { Endpoints } from '@/app/framework/misc/Endpoints'
import { injectable } from 'tsyringe'
import { TrainingMaterialReportRepositoryInterface } from '@/data/persistences/repositories/contracts/TrainingMaterialReportRepositoryInterface'
import {
  TrainingMaterialReport,
  Export,
} from '@/domain/entities/TrainingMaterialReport'
import { TrainingMaterialReportDataMapper } from '@/data/persistences/mappers/TrainingMaterialReportDataMapper'

@injectable()
export class TrainingMaterialReportApiRepository
  implements TrainingMaterialReportRepositoryInterface {
  private service: ApiService
  private mapper: TrainingMaterialReportDataMapper

  constructor(service: ApiService, mapper: TrainingMaterialReportDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async getAll(params: Object): Promise<TrainingMaterialReport> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.REPORT_TRAINING_MATERIAL,
      params
    )
    return this.mapper.convertTrainingMaterialReportFromApi(resp)
  }
  public async getExport(params: Object): Promise<Export> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.EXPORT_TRAINING,
      params
    )
    return this.mapper.convertExportFileFromAPi(resp)
  }
}
